import CircularProgress from '@mui/material/CircularProgress';
import { useEffect } from "react";
import "./Loader.css"
const Loader = () => {
    useEffect(() => {
        document.body.className = "loading-body";
        return () => {
            document.body.className = '';
        }
    }, []);

    return (
        <div className='loading-wrap'>
            <div className='icon'>
                <CircularProgress />
            </div>
            <span className='text'> Please Wait...</span>
        </div>
    )
}
export default Loader